export const IRREGULAR_STREAKS_PSEUDOPODS_ID =
  'a2c1c6a9-bd5b-4912-ae63-d3387aee34e4';

export const ADVANCED_EXAMINATION = '8213d871-b202-4328-9b75-45d84a7aee55';
export const COLOR_OPTION_ID = '99b1548f-9d78-4c1f-9217-fb1e4f796169';
export const BORDER_OPTION_ID = '57cc4ad5-ca07-4f62-86f7-5b1faebcb4ca';

export const BENIGN_SKIN_CONDITIONS = '64738cd1-7a8c-420e-a914-491d9dde2321';
export const PRE_MALIGNANT_SKIN_CONDITIONS =
  '1d3fc889-d250-4b64-b28d-3e515a31f7fa';
export const MALIGNANT_SKIN_CONDITIONS = '8a73903b-110d-4fd4-ac5b-8ca6c9a995d3';

export const LENTIGO_MALIGNA_ID = '64d7dbb2-db8d-4269-a30c-26a3b5b6265a';
export const MELANOMA_ID = 'a16e121c-2b95-4ac9-85ac-357172fae185';

export const RECOMMENDATION_OPTION_ID = 'bbf3772b-1eab-4ab1-82d3-c90e45591255';
